import { Component, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { MatSidenavModule } from '@angular/material/sidenav';
import { SidebarComponent } from './sidebar.component';
import { AuthService } from '../../../core/services/auth.service';

@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [
    RouterOutlet,
    MatSidenavModule,
    SidebarComponent
  ],
  template: `
    <mat-sidenav-container class="layout-container">
      <mat-sidenav mode="side" opened class="app-sidenav">
        <app-sidebar></app-sidebar>
      </mat-sidenav>
      <mat-sidenav-content class="main-content">
        <div class="content">
          <router-outlet></router-outlet>
        </div>
      </mat-sidenav-content>
    </mat-sidenav-container>
  `,
  styles: [`
    .layout-container {
      height: 100vh;
      background: #f8fafc;
    }

    .app-sidenav {
      width: 280px;
      border-right: none;
      box-shadow: 2px 0 8px rgba(0, 0, 0, 0.1);
    }

    .main-content {
      background: #f8fafc;
    }

    .content {
      padding: 32px;
      max-width: 1600px;
    }

    @media (max-width: 1200px) {
      .content {
        padding: 24px;
      }
    }

    @media (max-width: 768px) {
      .content {
        padding: 16px;
      }
    }
  `]
})
export class LayoutComponent implements OnInit {
  private auth = inject(AuthService);

  ngOnInit(): void {
    // Initialize current user from token if present
    if (this.auth.token) {
      this.auth.me().subscribe({
        next: () => {},
        error: () => this.auth.logout()
      });
    }
  }
}
